import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LanguageService } from '@dhats-hub/shared-ui';

@Component({
  standalone: true,
  imports: [RouterModule],
  selector: 'app-root',
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class AppComponent {
  title = 'frontend';

  // Injected here, not where the toggle lives, so the stored language is
  // applied before the first screen paints rather than after it.
  private readonly language = inject(LanguageService);
}
